<script setup lang="ts">
defineSlice({
  name: { label: 'Divider Full Width', group: 'Dividers', layouts: ['Atlantisbahamas', 'AtlantisMobileApp'] },
  description: 'Divider Full Width Slice',
  tags: ['Divider'],
  preview: 'SlicesGlueDividersDivider.jpg',
})
</script>

<template>
  <div class="w-[100%] h-[2px] bg-red-300 my-8 mx-auto" />
</template>
